import React from 'react'
import data from './en.json'

import { Subtitle } from './components/title'
import { Text } from './components/text'
import { Section } from './components/section'
import { Box } from './components/box'

import { Experiences } from './sections/experience'
import { Skills } from './sections/skill'
import { Splash } from './sections/splash'
import { Profile } from './sections/profile'
import { Footer } from './sections/footer'

function App() {
    const splash = React.useRef(null);
    const ref = React.useRef(null);

    React.useEffect(() => {
        window.history.scrollRestoration = 'manual'
    }, []);

    const scrollTo = (r) => r.current.scrollIntoView( {
        behavior: 'smooth', block: 'start'
    }) 

    return (
        <>
            <Section ref={ splash } style={{ margin:0, padding: 0}}>
                <Splash location={ data.profile.location } onClick={ () => scrollTo(ref) }/>
            </Section>

            <Section ref={ ref } style={{ paddingTop: '6em' }}>
                <Profile data={ data.profile }/>
            </Section>

            <Section divider>
                <Box gap="4em">
                    <Subtitle bold>{ data.skills.title }</Subtitle>
                    <Skills skills={ data.skills.items }/>
                </Box>
            </Section>

            <Section divider>
                <Box gap="4em">
                    <Subtitle bold>{ data.interests.title }</Subtitle>
                    <Text>{ data.interests.description}</Text>
                </Box>
            </Section>

            <Section divider>
                <Box gap="4em">
                    <Subtitle bold>{ data.experience.title }</Subtitle>
                    <Experiences experiences={ data.experience.items }/>
                </Box>
            </Section>

            <Footer/>
        </>
    );
}

export default App;
